import { render, staticRenderFns } from "./WaitingRoom.vue?vue&type=template&id=4bbd92ee&"
import script from "./WaitingRoom.vue?vue&type=script&lang=js&"
export * from "./WaitingRoom.vue?vue&type=script&lang=js&"
import style0 from "./WaitingRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports